exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".color-schema-pink-rich .uu5-bricks-page-menu-button:not([class^=\"uu5-bricks-button-inverted\"]):not([class*=\" uu5-bricks-button-inverted\"]):not([class*=\" uu5-bricks-button-inverted\"]):not([class*=\" uu5-bricks-button-inverted\"]):not([class^=\"color-schema-\"]):not([class*=\" color-schema-\"]) {\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: none;\n  outline: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/page-menu-button.less
// module id = 243
// module chunks = 0